var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglemap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 5.5,
    fill: "white",
    stroke: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5486 40.5943C24.8337 42.216 26.0033 43.9242 27.0489 45.7067C27.9417 47.383 28.3139 48.5197 28.9664 50.5395C29.3665 51.6554 29.7282 51.9885 30.5057 51.9885C31.353 51.9885 31.7374 51.4219 32.0344 50.5456C32.6511 48.6381 33.135 47.1824 33.8985 45.8069C35.3967 43.1513 37.2583 40.7915 39.0875 38.5235C39.5827 37.8816 42.7843 34.1421 44.2257 31.1915C44.2257 31.1915 45.9972 27.9502 45.9972 23.4235C45.9972 19.1892 44.2501 16.2524 44.2501 16.2524L39.2202 17.5863L36.1655 25.5532L35.4098 26.6518L35.2587 26.8508L35.0577 27.0999L34.7049 27.4979L34.2007 27.997L31.4806 30.1914L24.6799 34.0798L23.5486 40.5943Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5295 30.6465C18.1893 34.4006 21.39 37.7008 23.5555 40.5968L35.0576 27.105C35.0576 27.105 33.4372 29.2036 30.4977 29.2036C27.2236 29.2036 24.5785 26.6146 24.5785 23.3499C24.5785 21.1112 25.9386 19.5732 25.9386 19.5732L18.1307 21.645L16.5295 30.6464V30.6465Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1862 8.69372C39.0063 9.91337 42.276 12.4739 44.2537 16.2496L35.0613 27.0971C35.0613 27.0971 36.4214 25.5313 36.4214 23.3065C36.4214 19.9659 33.5806 17.4702 30.5118 17.4702C27.6098 17.4702 25.9431 19.5653 25.9431 19.5653V12.7315L35.1862 8.6936V8.69372Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6367 13.4868C20.9183 10.7836 24.9331 8 30.4681 8C33.1535 8 35.1766 8.69813 35.1766 8.69813L25.9344 19.5714H19.3862L18.6367 13.4869V13.4868Z",
    fill: "#1A73E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5297 30.6465C16.5297 30.6465 15.0027 27.6854 15.0027 23.3957C15.0027 19.3413 16.5943 15.7974 18.6367 13.4868L25.9396 19.5724L16.5297 30.6465Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglemap);
export default __webpack_public_path__ + "static/media/googlemap.cf1864b173bd9036452b387fc6864031.svg";
export { ForwardRef as ReactComponent };